import { render, staticRenderFns } from "./SwimpoolCoverPanels.vue?vue&type=template&id=b2071f26&scoped=true"
import script from "./SwimpoolCoverPanels.vue?vue&type=script&lang=ts"
export * from "./SwimpoolCoverPanels.vue?vue&type=script&lang=ts"
import style0 from "./SwimpoolCoverPanels.vue?vue&type=style&index=0&id=b2071f26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2071f26",
  null
  
)

export default component.exports